import { combineReducers } from '@reduxjs/toolkit'

import ContactUsModalReducer from '../components/ContactUs/ContactUsModalSlice'
import ErrorSliceReducer from '../components/ErrorBoundary/ErrorSliceReducer'
import LoaderSliceReducer from '../components/LoaderOverlay/LoaderSlice'
import XlsxValidationSliceReducer from '../components/XlsxValidationAlert/redux/XlsxValidationSliceReducer'
import AccountsReducer from '../pages/Admin/Accounts/redux/AccountsSlice' // For Admin (all accounts)
import AdminDashboardSliceReducer from '../pages/Admin/AdminDashboard/redux/AdminDashboardSlice'
import BlockedIpsReducer from '../pages/Admin/BlockedIps/redux/BlockedIpsSlice'
import BrokerIdentifiersReducer from '../pages/Admin/BrokerIdentifiers/redux/BrokerIdentifiersSlice'
import CommissionBenchmarkReducer from '../pages/Admin/CommissionBenchmark/redux/CommissionBenchmarkSlice'
import UsersReducer from '../pages/Admin/Users/redux/UsersSlice'
import AIMarketInsightsReducer from '../pages/AIMarketInsights/redux/AIMarketInsightsSlice'
import CashFlowReducer from '../pages/CashFlow/CashFlowSlice'
import DailyStatsReducer from '../pages/DailyStats/DailyStatsReducer'
import DashboardSliceReducer from '../pages/Dashboard/DashboardSlice'
import EducationReducer from '../pages/Education/EducationReducer'
import ReportsReducer from '../pages/Reports/ReportsSlice'
import SettingsSliceReducer from '../pages/Settings/SettingsSlice'
import TradingLogReducer from '../pages/TradingLog/TradingLogSlice'
import { tradingPlanReducer } from '../pages/TradingPlan/redux'
import WebinarsReducer from '../pages/Webinars/WebinarsReducer'
import authSliceReducer from '../user/authSlice'
import UserAccountsReducer from '../user/UserAccountsSlice' // For User, only Current userAccounts

import LocalJournalingReducer from './reducers/journalingReducerSlice'

export const rootReducer = {
  loader: LoaderSliceReducer,
  tokens: authSliceReducer,
  contactUsModal: ContactUsModalReducer,
  error: ErrorSliceReducer,
  xlsxValidation: XlsxValidationSliceReducer,
  tradingLog: TradingLogReducer,
  cashFlow: CashFlowReducer,
  dashboard: DashboardSliceReducer,
  dailyStats: DailyStatsReducer,
  settings: SettingsSliceReducer,
  userAccounts: UserAccountsReducer,
  users: UsersReducer,
  blockedIps: BlockedIpsReducer,
  accounts: AccountsReducer,
  brokerIdentifiers: BrokerIdentifiersReducer,
  commissionBenchmark: CommissionBenchmarkReducer,
  adminDashboard: AdminDashboardSliceReducer,
  localJournalingProgress: LocalJournalingReducer,
  reports: ReportsReducer,
  tradingPlan: tradingPlanReducer,
  education: EducationReducer,
  aiMarketInsights: AIMarketInsightsReducer,
  webinars: WebinarsReducer,
}

const combinedReducer = combineReducers(rootReducer)

export type RootState = ReturnType<typeof combinedReducer>
